import { render } from "./prospect-delete-modal.vue?vue&type=template&id=863864f6"
import script from "./prospect-delete-modal.vue?vue&type=script&lang=js"
export * from "./prospect-delete-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__